import { render } from "./Slider.vue?vue&type=template&id=78e94e4c"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=78e94e4c&lang=scss"
script.render = render

export default script